/**
 * 86d4889jb — single source for the DT status sets.
 *
 * There is no status enum anywhere in this system: Postgres stores plain
 * TEXT, and Prisma, GraphQL and TypeScript all carry it as `string`. Every
 * status list in the app is an independent hard-coded array, and both ways an
 * unknown value can surface are silent — `statusValueFormatter` returns "" for
 * a blank chip, and the dashboard's `default: break` drops it from the totals.
 * Nothing fails visibly when one array gets missed.
 *
 * These constants exist so the next status CR is one file instead of a grep
 * across nineteen. They are used ONLY in the arrays this CR already touches;
 * adopting them elsewhere is a separate cleanup.
 *
 * Deliberately `string[]` and not `as const`: these are values, never a type
 * constraint. Narrowing `main_status` on `IDeliveryTrip`, on the generated
 * GraphQL types, or in the yup schema would ripple into every `?filter=` route
 * and every ag-Grid filter model, none of which can promise a value from this
 * set. (A readonly `as const` tuple also will not assign to ag-Grid's
 * `values: string[]`.)
 */

/** The four values the status dropdown offers, in workflow order. */
export const DT_STATUS: string[] = [
  "booking",
  "wait_deliver",
  "delivering",
  "finished",
];

/**
 * Everything `aggrid_status` can hold. `late` is a flag that masks
 * `main_status`, and `cancelled` is driven from `flag_status` via ตัวเลือก —
 * neither is ever a dropdown choice, but both reach list and report filters.
 */
export const DT_STATUS_ALL: string[] = [
  "booking",
  "wait_deliver",
  "delivering",
  "late",
  "finished",
  "cancelled",
];
